exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dtOX6{margin-bottom:12px}._1pGAW{border-radius:0;width:100%;display:block;color:#585858;font-size:16px;padding-bottom:12px;border-bottom:1px solid #dce0e0}.Jt_2o{font-size:14px;color:inherit}._1JVbs{font-size:24px;line-height:1;font-weight:400;font-style:normal;color:#d9d9d9;display:block}._1T8cg{margin-bottom:18px}.H6v3s{padding-left:0;list-style:none;font-size:14px;line-height:1.43;color:#a4a7a9}.BCFxe{float:none;display:table-cell;vertical-align:middle}", ""]);

// exports
exports.locals = {
	"space2": "dtOX6",
	"panelHeader": "_1pGAW",
	"panelBody": "Jt_2o",
	"circleIcon": "_1JVbs",
	"space3": "_1T8cg",
	"listStyle": "H6v3s",
	"colMiddle": "BCFxe"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/VerifiedInfo/VerifiedInfo.css
// module id = 2577
// module chunks = 15